import { CheckCircle2, ShieldCheck } from 'lucide-react';

export const CheckoutSuccessView = ({
  successPaymentData,
  selectedPlan,
  effectiveCustomVoucherLimit,
  totalPlanAmount,
  formatCurrency,
  navigate
}) => {
  return (
    <div className="min-h-[70vh] bg-slate-50 flex items-center justify-center p-4 sm:p-6 font-sans">
      <div className="bg-white rounded-3xl border border-slate-200 p-6 sm:p-8 max-w-md w-full text-center space-y-5 shadow-xl animate-fadeIn">
        <div className="w-16 h-16 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto shadow-sm">
          <CheckCircle2 size={36} className="stroke-[2.5]" />
        </div>
        <div>
          <h2 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">Payment &amp; Mandate Authorized!</h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1">
            Your subscription mandate has been successfully verified and activated.
          </p>
        </div>

        <div className="p-4 rounded-2xl bg-teal-50/70 border border-teal-200/80 text-left text-xs space-y-2 text-slate-800">
          <div className="flex justify-between border-b border-teal-200/50 pb-2">
            <span className="text-slate-500 font-medium">Plan Activated:</span>
            <span className="font-bold text-slate-900">{successPaymentData?.plan_name || selectedPlan?.name} Tier</span>
          </div>
          <div className="flex justify-between border-b border-teal-200/50 pb-2">
            <span className="text-slate-500 font-medium">Amount Charged Today:</span>
            <span className="font-extrabold text-[#067978]">{formatCurrency(successPaymentData?.amount || totalPlanAmount)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500 font-medium">Subscription ID:</span>
            <span className="font-mono text-[11px] text-slate-700">{successPaymentData?.subscription_id || 'Activated'}</span>
          </div>
        </div>

        <p className="text-[11px] text-slate-400 leading-relaxed">
          Tax invoice receipt has been generated and queued for your registered email. You can safely close this tab or log in to your portal.
        </p>

        <div className="pt-2">
          <button
            onClick={() => navigate('/login')}
            className="w-full py-3 bg-[#067978] hover:bg-[#05605f] text-white font-bold text-xs sm:text-sm rounded-2xl shadow-md transition-all cursor-pointer"
          >
            Go to Agent Portal
          </button>
        </div>
      </div>
    </div>
  );
};

export const CheckoutCompletedView = ({ navigate }) => {
  return (
    <div className="min-h-[70vh] bg-slate-50 flex items-center justify-center p-4 sm:p-6 font-sans">
      <div className="bg-white rounded-3xl border border-slate-200/90 p-6 sm:p-7 max-w-md w-full text-center space-y-4 shadow-xl animate-fadeIn">
        <div className="w-14 h-14 rounded-2xl bg-emerald-50 border border-emerald-100 text-emerald-600 flex items-center justify-center mx-auto shadow-2xs">
          <ShieldCheck size={30} className="stroke-[2.2]" />
        </div>
        <div>
          <h2 className="text-lg sm:text-xl font-bold text-slate-800 tracking-tight">Mandate Already Completed</h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1 leading-relaxed">
            This custom plan payment mandate has already been authorized and activated for your agency. No further action is required.
          </p>
        </div>

        <div className="p-3.5 rounded-2xl bg-teal-50/70 border border-teal-200/70 text-xs text-center text-slate-700 font-medium">
          Status: <span className="font-bold text-[#067978]">Active &amp; Protected</span>
        </div>

        <div className="pt-1">
          <button
            onClick={() => navigate('/login')}
            className="w-full py-2.5 bg-[#067978] hover:bg-[#05605f] text-white font-semibold text-xs sm:text-sm rounded-xl shadow-md transition-all cursor-pointer"
          >
            Go to Agent Portal
          </button>
        </div>
      </div>
    </div>
  );
};
